import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Title } from "../../styles/commons";

const PageHeader = ({ title, children }) => {
  return (
    <div style={{ padding:'10px 20px',background:'#F6F7FB' }}>
      <Container fluid>
        <Row>
          <Col>
            <Title>{title}</Title>
            {children}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageHeader;
